// An empty range has no badge at all (WHN-2105: badge verbergen als de data
// leeg is); equal bounds collapse to a single value. Format follows the design:
// "89-92m²", no spaces. Shared by the project cards and the project panel so
// the same range never renders two ways.
export const formatAreaRange = (range) => {
  if (!range) return null;

  const { min, max } = range;
  if (min == null && max == null) return null;

  if (min != null && max != null) {
    return min === max ? `${min}m²` : `${min}-${max}m²`;
  }

  return `${min ?? max}m²`;
};
